import { Component, signal } from "@angular/core";
import { Based } from "../../shared/core/based/based";
import { Footer } from "../../shared/core/footer/footer";
import { Header } from "../../shared/core/header/header";
import { HowWeWork } from "../../shared/core/how-we-work/how-we-work";
import { OfficeSituation } from "../../shared/core/office-situation/office-situation";
import { SharingIsCaring } from "../../shared/core/sharing-is-caring/sharing-is-caring";
import { ShowYourSkills } from "../../shared/core/show-your-skills/show-your-skills";
import { TechnologiesWeUse } from "../../shared/core/technologies-we-use/technologies-we-use";
import { WantToJoin } from "../../shared/core/want-to-join/want-to-join";
import { Pill } from "../../shared/ui/pill/pill";

@Component({
  selector: "app-home",
  templateUrl: "./home.html",
  standalone: true,
  imports: [
    Header,
    Footer,
    Pill,
    Based,
    OfficeSituation,
    HowWeWork,
    TechnologiesWeUse,
    SharingIsCaring,
    WantToJoin,
    ShowYourSkills,
  ],
})
export class Home {
}
